import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {Possessed} from "../Possessed";
import {SimplePresentation} from "./presentations/SimplePresentationRunner";
import {FreespinsIntroPresentation} from "./presentations/FreespinsIntroPresentation";
import {PaddingPresentation} from "./presentations/PaddingPresentation";
import {SimplePresentationRunner} from "./presentations/SimplePresentationRunner";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

class DoFreespinsZeroBetPresentation extends SimplePresentation {
    constructor() {
        super("FreeSpinsZeroBet");

    }

    buildTimeline(): void {
        const tl = this.tl;
        tl.add(() => {
            SlotGame.apiPlugin.betHandler.zeroBet();
            SlotGame.keypadPlugin.setZeroBetSpinCounter(Possessed.model.data.freespinsLeft-1);
        });
    }
}

export class PossessedZeroBetIdlePresentation implements FlowStatePresentation {

    private presentations:SimplePresentation[] = [
        //new PaddingPresentation(0.5),
        new FreespinsIntroPresentation(),
        new DoFreespinsZeroBetPresentation()
    ];

    constructor() {

    }

    start(flowStateController:FlowStateController):void {
        //freespinsLeft is missing from the init data in exorcism, that's why this is here.
        if (!Possessed.model.isRestore){
            SlotGame.keypadPlugin.setZeroBetSpinCounter(Possessed.model.gameData.freespinsLeft-1);
        }
        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "FS intro runner");
    }

}